/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import type {CatalogItemId, MaterialFunctionAssignmentInput, MaterialFunctionId} from "../model";

import {customFetch} from "../../../runtime/custom-fetch";

export const getAddMaterialFunctionUrl = (id: CatalogItemId) => {
  return `/api/v1/engineering/materials/${id}/functions`;
};

/**
 * @summary Add material function
 */
export const addMaterialFunction = async (
  id: CatalogItemId,
  materialFunctionAssignmentInput: MaterialFunctionAssignmentInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<MaterialFunctionId> => {
  return customFetch<MaterialFunctionId>(getAddMaterialFunctionUrl(id), {
    ...options,
    method: "POST",
    headers: {"Content-Type": "application/json", ...options?.headers},
    body: JSON.stringify(materialFunctionAssignmentInput),
  });
};

export const getRemoveMaterialFunctionUrl = (id: CatalogItemId, functionId: MaterialFunctionId) => {
  return `/api/v1/engineering/materials/${id}/functions/${functionId}`;
};

/**
 * @summary Remove material function
 */
export const removeMaterialFunction = async (
  id: CatalogItemId,
  functionId: MaterialFunctionId,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getRemoveMaterialFunctionUrl(id, functionId), {
    ...options,
    method: "DELETE",
  });
};
